/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Queue_Erp_Files_To_ImportInputs */

const en_queue_erp_files_to_import = /** @type {(inputs: Queue_Erp_Files_To_ImportInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Files to the ERP to import`)
};

/**
* | output |
* | --- |
* | "Files to the ERP to import" |
*
* @param {Queue_Erp_Files_To_ImportInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const queue_erp_files_to_import = /** @type {((inputs?: Queue_Erp_Files_To_ImportInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Queue_Erp_Files_To_ImportInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_queue_erp_files_to_import(inputs)
});